<div class="footer-container">
  <div class="left">
    <div class="logo">
      <img src="../../assets/images/footer-logo.png" alt="" />
    </div>
    <div class="label">
      <div class="label1">
        Your learning journey, supported by professionals.
      </div>
      <div class="links">
        <a routerLink="about" (click)="onClickLink('about')" class="link1">About Us</a>
        <a routerLink="pricing" (click)="onClickLink('pricing')" class="link2">Pricing</a>
        <a routerLink="contact" (click)="onClickLink('contact')" class="link3">Contact Us</a>
        <a routerLink="login" (click)="onClickLink('login')" class="link4">Student Login</a>
        <a routerLink="blogs" (click)="onClickLink('blogs')" class="link5">Blog</a>
      </div>
    </div>
  </div>
  <div class="right">
    <div class="social-media-icons">
      <div class="icon" *ngFor="let icon of socialMediaIcons" (click)="onClickIcon(icon)">
        <i [class]="icon.class"></i>
      </div>
    </div>
    <div class="copyright">
      &#169; 2026
      <span class="logo-name">The <span class="lab">Lab</span>oratory Matters</span>
    </div>
  </div>
</div>